import * as Tone from 'tone'
import { clamp01 } from '../utils/clamp'

export type FxParam = 'volume' | 'fuzz' | 'delay' | 'reverb'

export interface FxBus {
  input: Tone.ToneAudioNode
  setParam(param: FxParam, value01: number): void
  dispose(): void
  ready: Promise<void>
}

export function createFxBus(): FxBus {
  const fuzz = new Tone.Distortion({ distortion: 0, wet: 1 })
  const volume = new Tone.Gain(1)
  const delay = new Tone.FeedbackDelay({ delayTime: '8n', feedback: 0.35, wet: 0 })
  const reverb = new Tone.Reverb({ decay: 2.5, preDelay: 0.02, wet: 0 })

  fuzz.chain(volume, delay, reverb, Tone.getDestination())

  function setParam(param: FxParam, value01: number) {
    const v = clamp01(value01)
    switch (param) {
      case 'volume':
        volume.gain.rampTo(v, 0.02)
        break
      case 'fuzz':
        fuzz.distortion = v
        break
      case 'delay':
        delay.wet.rampTo(v, 0.02)
        break
      case 'reverb':
        reverb.wet.rampTo(v, 0.02)
        break
    }
  }

  return {
    input: fuzz,
    setParam,
    dispose() {
      fuzz.dispose()
      volume.dispose()
      delay.dispose()
      reverb.dispose()
    },
    ready: reverb.ready,
  }
}
